import { Breadcrumb, ConfigProvider, Flex, Space, Tabs } from "antd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import SettingNotiEmil from "./SettingNotiEmil";
import { useState } from "react";
import SettingNotifyPage from "../pages/SettingNotifyPage";

const NotiSetting = () => {
    const { t } = useTranslation();
    const [selectedMenu, setSelectedMenu] = useState('setting_email');

    const menuBreadcrumbMapping = {
        'setting_email': t('setting_notification.label.email_notification'),
        'setting_notify': t('setting_notification.label.notify'),
    }

    const handleTabChange = (key) => {
        setSelectedMenu(key);
    };

    return (
        <MainLayout>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("masterdata.header"), href: "" },
                        { title: t("setting_notification.header"), href: "" },
                        { title: menuBreadcrumbMapping[selectedMenu] || null }
                    ]} />
                    <h2>{menuBreadcrumbMapping[selectedMenu] || null}</h2>
                </Flex>

                <ConfigProvider
                    theme={{
                        components: {
                            Tabs: {
                                itemHoverColor: "var(--tab-color)",
                                itemActiveColor: "var(--tab-color)"
                            },
                        },
                    }}
                >
                    <Tabs destroyInactiveTabPane={true} defaultActiveKey="setting_email" onChange={handleTabChange}>
                        {
                            <Tabs.TabPane tab={t('setting_notification.label.email_notification')} key="setting_email">
                                <SettingNotiEmil />
                            </Tabs.TabPane>
                        }
                        {
                            <Tabs.TabPane tab={t('setting_notification.label.notify')} key="setting_notify">
                                <SettingNotifyPage />
                            </Tabs.TabPane>
                        }
                    </Tabs>
                </ConfigProvider>
            </Space>
        </MainLayout>
    )
}

export default NotiSetting;